import { TRAINABILITY_LEVELS, V2_TRAINABILITY_LEVEL_META } from "../../common/TrainabilityLevels";

export const V2_ZONES = TRAINABILITY_LEVELS.map((key) => ({
  key,
  color: V2_TRAINABILITY_LEVEL_META[key].color,
  text: V2_TRAINABILITY_LEVEL_META[key].textColor,
}));

export const FOLDED_ZONE_BANDS = [
  { key: "underload", start: 0, end: 20, fill: "rgba(255, 255, 255, 0.06)" },
  { key: "suboptimal", start: 20, end: 40, fill: "rgba(77, 132, 255, 0.16)" },
  { key: "optimal", start: 40, end: 55, fill: "rgba(0, 255, 140, 0.10)" },
  { key: "supraoptimal", start: 55, end: 80, fill: "rgba(255, 166, 48, 0.14)" },
  { key: "overload", start: 80, end: 100, fill: "rgba(255, 77, 94, 0.18)" },
];

export const FOLDED_AXIS_TICKS = [
  { label: "0", at: 100 },
  { label: "4", at: 80 },
  { label: "10", at: 50 },
  { label: "4", at: 20 },
  { label: "0", at: 0 },
];

export const V2_ZONE_META = Object.fromEntries(V2_ZONES.map((zone) => [zone.key, zone]));

export const V2_POSITIONS = [
  { id: "GK", labelKey: "v2.overview.positions.gk" },
  { id: "DEF", labelKey: "v2.overview.positions.def" },
  { id: "LAT", labelKey: "v2.overview.positions.lat" },
  { id: "MIL", labelKey: "v2.overview.positions.mil" },
  { id: "ATT", labelKey: "v2.overview.positions.att" },
];

export function getInitials(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function foldedLeftPercent(score, zone) {
  const value = Number(score);
  const numeric = Number.isFinite(value) ? value : 0;
  const resolvedZone = zone || "underload";

  if (resolvedZone === "underload") return (clamp(numeric, 0, 4) / 4) * 20;
  if (resolvedZone === "suboptimal") return 20 + ((clamp(numeric, 4, 8) - 4) / 4) * 20;
  if (resolvedZone === "optimal") {
    if (numeric >= 9.15) return 50 + ((10 - clamp(numeric, 9, 10)) / 1) * 5;
    return 40 + ((clamp(numeric, 8, 10) - 8) / 2) * 10;
  }
  if (resolvedZone === "supraoptimal") return 55 + ((9 - clamp(numeric, 4, 9)) / 5) * 25;
  return 80 + ((4 - clamp(numeric, 0, 4)) / 4) * 20;
}

export function formatScore(value, digits = 1) {
  if (!Number.isFinite(Number(value))) return "—";
  return Number(value).toFixed(digits).replace(".", ",");
}

export function formatPercent(value, digits = 1) {
  return `${formatScore(value, digits)} %`;
}

export function formatDelta(value, unit = "pt") {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  const sign = number > 0 ? "+" : "";
  return `${sign}${formatScore(number)} ${unit}`;
}

export function zoneFromScore(score) {
  if (score < 4) return "underload";
  if (score < 8) return "suboptimal";
  if (score <= 10 && score >= 8) return "optimal";
  return "optimal";
}

export function resolveFoldedZone(storedZone, player, score) {
  if (storedZone) return storedZone;
  if (player?.zone) return player.zone;
  if (player?.musclesToTreat?.length) return "overload";
  return zoneFromScore(score) || "underload";
}

export function matchesPosition(player, selectedPositions) {
  if (!selectedPositions?.length) return true;
  return selectedPositions.includes(player.position);
}
